import { EnrichmentConfig } from "../../types/api";

export const validateConfig = (config: EnrichmentConfig): {
  valid: boolean;
  errors: {
    field: string,
    message: string
  }[];
} => {
  const errors: {
    field: string,
    message: string
  }[] = [];
  if (config.general.language === "") {
    errors.push({
      field: "general.language",
      message: "Language is required"
    });
  }
  if (config.general.writing_style === "") {
    errors.push({
      field: "general.writing_style",
      message: "Writing style is required"
    });
  }
  // if(config.title.generate){
  //   if(config.title.prompt === ""){
  //     errors.push({
  //       field: "title.prompt",
  //       message: "Prompt is required"
  //     });
  //   }
  // }
  // if(config.description.generate){
  //   if(config.description.prompt === ""){
  //     errors.push({
  //       field: "description.prompt",
  //       message: "Prompt is required"
  //     });
  //   }
  // }
  // if(config.alt_text.generate){
  //   if(config.alt_text.prompt === ""){
  //     errors.push({
  //       field: "alt_text.prompt",
  //       message: "Prompt is required"
  //     });
  //   }
  // }
  return {
    valid: errors.length === 0,
    errors,
  };
}